import { TwitterShareButton } from 'react-twitter-embed';
import { useSelector } from 'react-redux';

const XButton = ({ globalAssetId, title }) => {
    const channelGuid = useSelector(state => state.channel.channelGuid);

    const baseUrl = process.env.REACT_APP_ARTICLE_URL || 'http://localhost:3000';
    const articleUrl = `${baseUrl}/article/${channelGuid}/${globalAssetId}`;

    return (
        <div className="pull-right">
            < TwitterShareButton
                url={articleUrl}
                options={{ text: title }}
            />
        </div>
    )
}

export default XButton
